import { usePermalinkToken } from '../session/permalinkToken'
import { useNavigation } from '../../utils/contexts/NavigationContext'

export const usePermalinkNavigation = () => {
  const navigate = useNavigation()
  const token = usePermalinkToken()
  return path => navigate(path + (!!token ? `?t=${token}` : ''))
}
